import script from "./LockModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__